import { useState } from 'react'
import { Button } from '@/components/ui/button'
import ProdottiList from './ProdottiList'
import BoxFiglieList from './BoxFiglieList'

/**
 * Wrapper della sezione Prodotti con tab "Prodotti" e "Box Figlie".
 * Punto 14 del feedback cliente: rendere visibile la giacenza delle box figlie
 * (scatoline pronte) dentro la sezione Prodotti.
 */
export default function ProdottiPage() {
  const [activeTab, setActiveTab] = useState('prodotti')

  return (
    <div className="space-y-4">
      <div className="flex gap-2 border-b">
        <Button
          variant={activeTab === 'prodotti' ? 'default' : 'ghost'}
          onClick={() => setActiveTab('prodotti')}
          className="rounded-b-none"
        >
          Prodotti
        </Button>
        <Button
          variant={activeTab === 'box_figlie' ? 'default' : 'ghost'}
          onClick={() => setActiveTab('box_figlie')}
          className="rounded-b-none"
        >
          Box Figlie
        </Button>
      </div>

      {activeTab === 'prodotti' ? <ProdottiList /> : <BoxFiglieList />}
    </div>
  )
}
